import script from "./certification_list.vue?vue&type=script&setup=true&lang=js"
export * from "./certification_list.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__